import React from 'react';
import './Banner.css';

function Banner() {
  return (
    <section className="banner" id="home">
      <div className="banner-overlay">
        <h1>Leal Transporte Executivo</h1>
        <p>Conforto e Segurança em Primeiro Lugar</p>
        <a href="#contact" className="btn-banner">Solicitar Orçamento</a>
      </div>
    </section>
  );
}

export default Banner;
